import React from "react";

export default function SystemMessage({ key, message }) {
  return (
    <div
      key={key}
      style={{
        maxWidth: "70%",
        padding: "0.6rem 1rem",
        borderRadius: "12px",
        fontSize: "0.95rem",
        whiteSpace: "pre-wrap",
        position: "relative",
        alignSelf: "center",
        color: "#888",
        backgroundColor: "transparent",
      }}
    >
      <div>{message}</div>
    </div>
  );
}